import ProductDescription from './ProductDescription'

const BreadProduct = {
  ...ProductDescription,
  category: '16',
  subCategory: '001',
  IsBroadband: true,
  BreadType: '',
  BreadSize: '',
  WholeWheatCert: false,
}

export default BreadProduct
